
const categories: { [slug: string] : string } = {
  // Vehicles
  electricCars: "Electric Cars",
  pluginHybrids: "Plug-in Hybrids",
  electricVans: "Electric Vans",
  compareEV: "Compare EV's",

  // Learn
  "nevo-news": "Nevo News",
  articles: "EV Eduation",
  "video-review": "Videos",
  "ev-series": "EV Series",
  asknevo: "#AskNevo",

  // Partners
  partners: "Our Partners"
};

export default categories;
